import React, { useEffect, useState } from "react";
import { useSearchParams, useNavigate } from "react-router-dom";
import axios from "axios";

const API = process.env.REACT_APP_DOMINI_API_CIUDAD;

const post = (url, data) =>
    axios.post(API + url,
        Object.entries(data).map(([k,v]) => `${encodeURIComponent(k)}=${encodeURIComponent(v)}`).join('&'),
        { headers: { 'Content-Type': 'application/x-www-form-urlencoded' }, withCredentials: true }
    ).then(r => r.data);

const get = (url) =>
    axios.get(API + url, { withCredentials: true }).then(r => r.data);

export const ResetPasswordScreen = () => {
    const [params]    = useSearchParams();
    const navegacio   = useNavigate();
    const token       = params.get('token') || '';
    const mode        = params.get('mode') || 'recuperar'; // 'activar' | 'recuperar'

    const [estat, setEstat]         = useState('validant'); // validant | formulari | ok | error
    const [errorToken, setErrorToken] = useState('');
    const [pwd,   setPwd]           = useState('');
    const [pwd2,  setPwd2]          = useState('');
    const [show1, setShow1]         = useState(false);
    const [show2, setShow2]         = useState(false);
    const [error, setError]         = useState('');
    const [enviant, setEnviant]     = useState(false);

    // Validar token al montar
    useEffect(() => {
        if (!token) { setEstat('error'); setErrorToken('Enlace no válido.'); return; }
        get(`/auth/verificar-token?token=${encodeURIComponent(token)}`)
            .then(data => {
                if (data.ok) setEstat('formulari');
                else { setEstat('error'); setErrorToken(data.msg || 'Enlace no válido o expirado.'); }
            })
            .catch(() => { setEstat('error'); setErrorToken('Error de conexión.'); });
    }, [token]);

    const validar = () => {
        if (pwd.length < 8)              return 'La contraseña debe tener al menos 8 caracteres.';
        if (!/[A-Z]/.test(pwd))          return 'Debe contener al menos una mayúscula.';
        if (!/[0-9]/.test(pwd))          return 'Debe contener al menos un número.';
        if (pwd !== pwd2)                return 'Las contraseñas no coinciden.';
        return '';
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        const err = validar();
        if (err) { setError(err); return; }
        setError('');
        setEnviant(true);
        try {
            const data = await post('/auth/reset-password', { token, password: pwd });
            if (data.ok) setEstat('ok');
            else setError(data.msg || 'Error al guardar la contraseña.');
        } catch {
            setError('Error de conexión. Inténtalo de nuevo.');
        } finally {
            setEnviant(false);
        }
    };

    const esActivar = mode === 'activar';

    return (
        <div style={{ minHeight: '100vh', background: '#f9fafb', display: 'flex', alignItems: 'center', justifyContent: 'center', padding: 24 }}>
            <div style={{ background: '#fff', borderRadius: 20, width: '100%', maxWidth: 440, boxShadow: '0 20px 60px rgba(0,0,0,0.1)', overflow: 'hidden' }}>

                {/* Header */}
                <div style={{ background: '#111827', padding: '28px 36px' }}>
                    <div style={{ fontSize: 13, color: '#9ca3af', fontWeight: 600, marginBottom: 4 }}>Ciudad que Cuida</div>
                    <div style={{ fontSize: 20, color: '#fff', fontWeight: 700 }}>
                        {esActivar ? 'Activar cuenta' : 'Restablecer contraseña'}
                    </div>
                </div>

                <div style={{ padding: '36px' }}>

                    {/* ── Validando token ── */}
                    {estat === 'validant' && (
                        <div style={{ textAlign: 'center', padding: '20px 0', color: '#6b7280', fontSize: 14 }}>
                            Verificando enlace...
                        </div>
                    )}

                    {/* ── Token inválido / expirado ── */}
                    {estat === 'error' && (
                        <div style={{ textAlign: 'center' }}>
                            <div style={{ fontSize: 48, marginBottom: 16 }}>⏱️</div>
                            <h3 style={{ margin: '0 0 10px', fontSize: 18, fontWeight: 700, color: '#111827' }}>Enlace no válido</h3>
                            <p style={{ margin: '0 0 28px', fontSize: 14, color: '#6b7280', lineHeight: 1.6 }}>
                                {errorToken}<br />
                                Si necesitas acceder, solicita un nuevo enlace desde la pantalla de login.
                            </p>
                            <button onClick={() => navegacio('/login')}
                                style={{ padding: '10px 28px', borderRadius: 9, fontSize: 14, fontWeight: 600, background: '#111827', color: '#fff', border: 'none', cursor: 'pointer' }}>
                                Ir al login
                            </button>
                        </div>
                    )}

                    {/* ── Formulario nueva contraseña ── */}
                    {estat === 'formulari' && (
                        <>
                            <p style={{ margin: '0 0 24px', fontSize: 14, color: '#6b7280', lineHeight: 1.5 }}>
                                {esActivar
                                    ? 'Crea una contraseña para activar tu cuenta. Debe tener al menos 8 caracteres, una mayúscula y un número.'
                                    : 'Introduce tu nueva contraseña. Debe tener al menos 8 caracteres, una mayúscula y un número.'}
                            </p>

                            {error && (
                                <div style={{ padding: '10px 14px', background: '#fef2f2', border: '1px solid #fecaca', borderRadius: 8, color: '#dc2626', fontSize: 13, marginBottom: 20 }}>
                                    {error}
                                </div>
                            )}

                            <div style={{ marginBottom: 16 }}>
                                <label style={labelStyle}>Nueva contraseña</label>
                                <div style={{ position: 'relative' }}>
                                    <input type={show1 ? 'text' : 'password'} value={pwd}
                                        onChange={e => setPwd(e.target.value)}
                                        placeholder="Mín. 8 caracteres, 1 mayúscula, 1 número"
                                        style={{ ...inputStyle, paddingRight: 44 }} />
                                    <button type="button" onClick={() => setShow1(!show1)}
                                        style={eyeBtn}>
                                        <i className={show1 ? 'bi-eye-slash' : 'bi-eye'} style={{ fontSize: 16 }}></i>
                                    </button>
                                </div>
                                {/* Indicador de fortaleza */}
                                {pwd && <PasswordStrength pwd={pwd} />}
                            </div>

                            <div style={{ marginBottom: 28 }}>
                                <label style={labelStyle}>Repetir contraseña</label>
                                <div style={{ position: 'relative' }}>
                                    <input type={show2 ? 'text' : 'password'} value={pwd2}
                                        onChange={e => setPwd2(e.target.value)}
                                        placeholder="Repite la contraseña"
                                        style={{ ...inputStyle, paddingRight: 44, borderColor: pwd2 && pwd !== pwd2 ? '#f87171' : '#e5e7eb' }} />
                                    <button type="button" onClick={() => setShow2(!show2)} style={eyeBtn}>
                                        <i className={show2 ? 'bi-eye-slash' : 'bi-eye'} style={{ fontSize: 16 }}></i>
                                    </button>
                                </div>
                                {pwd2 && pwd !== pwd2 && (
                                    <p style={{ fontSize: 12, color: '#dc2626', margin: '5px 0 0' }}>Las contraseñas no coinciden</p>
                                )}
                                {pwd2 && pwd === pwd2 && pwd2.length >= 8 && (
                                    <p style={{ fontSize: 12, color: '#16a34a', margin: '5px 0 0' }}>✓ Las contraseñas coinciden</p>
                                )}
                            </div>

                            <button onClick={handleSubmit} disabled={enviant}
                                style={{ width: '100%', padding: '12px', borderRadius: 10, fontSize: 15, fontWeight: 700, background: '#111827', color: '#fff', border: 'none', cursor: enviant ? 'wait' : 'pointer' }}>
                                {enviant ? 'Guardando...' : (esActivar ? 'Activar cuenta' : 'Guardar contraseña')}
                            </button>
                        </>
                    )}

                    {/* ── Éxito ── */}
                    {estat === 'ok' && (
                        <div style={{ textAlign: 'center' }}>
                            <div style={{ fontSize: 52, marginBottom: 16 }}>✅</div>
                            <h3 style={{ margin: '0 0 10px', fontSize: 18, fontWeight: 700, color: '#111827' }}>
                                {esActivar ? '¡Cuenta activada!' : '¡Contraseña actualizada!'}
                            </h3>
                            <p style={{ margin: '0 0 28px', fontSize: 14, color: '#6b7280', lineHeight: 1.6 }}>
                                {esActivar
                                    ? 'Tu cuenta está lista. Ya puedes iniciar sesión con tu nueva contraseña.'
                                    : 'Tu contraseña se ha actualizado correctamente. Ya puedes iniciar sesión.'}
                            </p>
                            <button onClick={() => navegacio('/login')}
                                style={{ padding: '10px 32px', borderRadius: 9, fontSize: 14, fontWeight: 600, background: '#111827', color: '#fff', border: 'none', cursor: 'pointer' }}>
                                Ir al login
                            </button>
                        </div>
                    )}
                </div>
            </div>
        </div>
    );
};

// ── Indicador de fortaleza de contraseña ─────────────────────────────────────
const PasswordStrength = ({ pwd }) => {
    const checks = [
        { ok: pwd.length >= 8,        label: '8 caracteres' },
        { ok: /[A-Z]/.test(pwd),      label: 'Mayúscula'    },
        { ok: /[0-9]/.test(pwd),      label: 'Número'       },
        { ok: /[^A-Za-z0-9]/.test(pwd), label: 'Símbolo'   },
    ];
    const score = checks.filter(c => c.ok).length;
    const colors = ['#ef4444','#f97316','#eab308','#22c55e'];
    const labels = ['Muy débil','Débil','Regular','Fuerte'];
    return (
        <div style={{ marginTop: 8 }}>
            <div style={{ display: 'flex', gap: 4, marginBottom: 6 }}>
                {[0,1,2,3].map(i => (
                    <div key={i} style={{ flex: 1, height: 3, borderRadius: 4, background: i < score ? colors[score-1] : '#e5e7eb', transition: 'background 0.2s' }} />
                ))}
            </div>
            <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                <div style={{ display: 'flex', gap: 8, flexWrap: 'wrap' }}>
                    {checks.map((c, i) => (
                        <span key={i} style={{ fontSize: 11, color: c.ok ? '#16a34a' : '#9ca3af' }}>
                            {c.ok ? '✓' : '○'} {c.label}
                        </span>
                    ))}
                </div>
                {score > 0 && <span style={{ fontSize: 11, fontWeight: 600, color: colors[score-1] }}>{labels[score-1]}</span>}
            </div>
        </div>
    );
};

const labelStyle = { fontSize: 12, fontWeight: 600, color: '#374151', display: 'block', marginBottom: 6 };
const inputStyle = { width: '100%', padding: '10px 13px', fontSize: 14, border: '1.5px solid #e5e7eb', borderRadius: 8, outline: 'none', boxSizing: 'border-box', color: '#111827' };
const eyeBtn     = { position: 'absolute', right: 12, top: '50%', transform: 'translateY(-50%)', background: 'none', border: 'none', cursor: 'pointer', color: '#9ca3af', padding: 0 };
